module.exports = __webpack_public_path__ + "static/media/arrow-left.89ec7fd9.svg";